import React from 'react';
import { classnames, TArg } from 'tailwindcss-classnames';

export type LayoutColumnsGridProps = {
  columns: 2 | 3 | 4 | 5;
  children: React.ReactNode | React.ReactNode[];
};

const gridCols: Record<number, TArg> = {
  2: 'grid-cols-2',
  3: 'grid-cols-3',
  4: 'grid-cols-4',
  5: 'grid-cols-5',
};

const columnCss = classnames('col-span-1', 'mb-6', 'last:mb-0', 'lg:mb-0');

const LayoutColumnsGrid = ({ columns, children }: LayoutColumnsGridProps): JSX.Element => (
  <div className={classnames('lg:grid', gridCols[columns], 'lg:gap-7')}>{children}</div>
);

export { columnCss };
export default LayoutColumnsGrid;
